import React from 'react';
import classnames from 'classnames';
import {  Menu,  MenuItems,  MenuButton,  MenuItem, MenuPopover} from "@reach/menu-button";
import { getDisplayName } from '../../utils/userUtils';

const AddSubmitterButton = ({
    buttonClassName = '',
    options = [],
    activeSubmitters = [],
    onItemSelect = () => {}
}) => {
    return (
        <Menu
            onKeyDown={e => {
                e.stopPropagation();
                e.preventDefault();
                return false;
            }}
        >
            <MenuButton className={classnames('js-add-submitter button mr-1', buttonClassName)}>Add Submitter</MenuButton>
            <MenuPopover>
                <MenuItems>
                    {options.map(user =>
                        <MenuItem key={user._id} onSelect={() => onItemSelect(user)}>{getDisplayName(user)} - {user.email}</MenuItem>
                    )}
                    <MenuItem className="text-danger" onSelect={() => onItemSelect('clear')}>Remove all Submitters</MenuItem>
                </MenuItems>
            </MenuPopover>
        </Menu>
    )
};

export default AddSubmitterButton;